var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#4B5967"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37021 5C4.28138 5 4.19667 5.01766 4.11927 5.04877L7.81678 8.4675C7.97547 8.61421 8.11773 8.61428 8.27682 8.4675L11.9811 5.04877C11.9037 5.01766 11.819 5 11.7302 5H4.37017H4.37021ZM3.70809 5.5785C3.70421 5.60783 3.70117 5.63855 3.70117 5.66905V10.3527C3.70117 10.7233 3.99955 11.0218 4.3703 11.0218H11.7303C12.1009 11.0218 12.3994 10.7234 12.3994 10.3527V5.66905C12.3994 5.63856 12.3964 5.60783 12.3924 5.57843L8.73333 8.95872C8.3496 9.31296 7.74395 9.3135 7.36032 8.95872L3.70821 5.57843L3.70809 5.5785Z",
    fill: "#10171F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b7d176874b5162a91fcbeb474184c7b2.svg";
export { ForwardRef as ReactComponent };